// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"405c40dd","766":"3fc1d028"}[chunkId] + ".chunk.js";
};